// @core/api/endpoints/authn/check_oidc_session.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CheckOIDCSessionRequest,
  CheckOIDCSessionResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Check OIDC session status
 * Verifies if an OIDC session is still active and returns associated user information. Used by relying parties to implement session management and single logout.
 * @public This endpoint does not require authentication
 */
export async function CheckOIDCSession(
  data: CheckOIDCSessionRequest,
  options?: RequestOptions
): Promise<CheckOIDCSessionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oidc/session/check`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<CheckOIDCSessionResponse>(requestPath, data, requestOptions);
}
